{
  "slug": "what-is-iq",
  "title": "আই. কিউ. কি?",
  "description": "আইকিউ মানে কি, আইকিউ টেস্ট কি পরিমাপ করে এবং বুদ্ধিমত্তার গুণফলের গুরুত্বপূর্ণ সীমাবদ্ধতা জানুন।",
  "summary": "আইকিউ, বুদ্ধিমত্তার গুণক, একটি মানবিক স্কোর যা নির্বাচিত কাজের ক্ষেত্রে একই বয়সের লোকদের তুলনায় কর্মদক্ষতা বর্ণনা করার জন্য তৈরি করা হয়েছে।",
  "sections": [
    {
      "heading": "IQ স্কোর কি প্রতিনিধিত্ব করে",
      "paragraphs": [
        "আধুনিক আই. কিউ. পরীক্ষার ফলাফল সাবধানে নকশাকৃত কাজের ফলাফলকে একত্রিত করে এবং তাদের একটি প্রতিনিধি রেফারেন্স গ্রুপের সাথে তুলনা করে। স্কেলটি সাধারণত. 100, তাই একটি ফলাফল বর্ণনা আপেক্ষিক কার্যকারিতা পরিবর্তে একটি সম্পূর্ণ পরিমাণ বুদ্ধিমত্তা.",
        "স্কোরকে একটি অনুমান হিসেবেই ভালোভাবে বুঝতে হবে। পরীক্ষার পরিবেশ, স্বাস্থ্য, ভাষা, উৎসাহ, পরীক্ষার ফরম্যাটের সাথে পরিচিত হওয়া এবং সাধারণ পরিমাপের ভুল সবকিছুই ফলাফলে প্রভাব ফেলতে পারে।"
      ]
    },
    {
      "heading": "আই. আই. সি. পরীক্ষায় সাধারণত যা মূল্যায়ন করা হয়",
      "paragraphs": [
        "পেশাদার ব্যাটারি এক ধরনের ধাঁধায় নির্ভর না করে অনেকগুলো বিবেচনাগত ক্ষমতার নমুনা নেয়।"
      ],
      "bullets": [
        "শব্দগত বুঝাপড়া এবং অর্জিত জ্ঞান",
        "দৃশ্যমান-স্থানীয় এবং তরল যুক্তি",
        "কর্মক্ষম স্মৃতিশক্তি এবং মনোযোগ",
        "প্রসেসিং গতি"
      ]
    },
    {
      "heading": "আই. কে. কি পরিমাপ করে না",
      "paragraphs": [
        "আইকিউ সৃজনশীলতা, বাস্তবিক বিচার, কৌতূহল, আবেগগত দক্ষতা, প্রেরণা, জ্ঞান বা বিশেষজ্ঞ জ্ঞানকে সম্পূর্ণভাবে ধরে রাখে না।",
        "একজন যোগ্য পেশাদার দ্বারা পরিচালিত মূল্যায়ন চিকিৎসা, শিক্ষা বা আইনগত সিদ্ধান্ত গ্রহণের জন্য বেশী উপযুক্ত। অনলাইন আইকিউ-শৈলীর ফলাফলটি নির্দেশক হিসেবেই থাকতে হবে।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "আই. কিউ. কিসের জন্য?",
      "answer": "আইকিউ মানে বুদ্ধিমত্তার গুণফল, যা বয়সভিত্তিক একটি রেফারেন্স গ্রুপের সাথে নির্বাচিত জ্ঞানগত কার্যকারিতা তুলনা করে একটি মানক স্কোর।"
    },
    {
      "question": "অনলাইন আইকিউ টেস্ট কি কোন রোগ নির্ণয়?",
      "answer": "না, অনলাইনে পাওয়া ফলাফলগুলো শুধুমাত্র আনুমানিক এবং কোন দক্ষ পেশাদার ব্যক্তির দ্বারা করা মূল্যায়নের বদলে নেয়া উচিত নয়।"
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "what-is-the-average-iq"]
}
